import React from "react";
import { Box, Typography } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning"; // MUI icon

interface HostCardFailedPaymentOverlayProps {
  fullWidth?: boolean; // optional: overlay width
}

const HostCardFailedPaymentOverlay: React.FC<HostCardFailedPaymentOverlayProps> = ({
  fullWidth = false,
}) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: fullWidth ? "100%" : "90%",
        height: "100%",
        bgcolor: "rgba(0, 0, 0, 0.6)",
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        p: 2,
      }}
    >
      <Typography
        variant="h6"
        fontWeight="bold"
        color="white"
        mb={1}
        display="flex"
        alignItems="center"
        gap={1}
      >
        <WarningIcon fontSize="inherit" /> Subscription Issue!
      </Typography>
      <Typography variant="body1" color="white">
        Subscription not active for this location!
        <br />
        Please contact us or update payment information!
      </Typography>
    </Box>
  );
};

export default HostCardFailedPaymentOverlay;
